import {
  ENDPOINT_CURRENT_USER,
  ENDPOINT_DISTRICTS,
  ENDPOINT_FOND_TYPES,
  ENDPOINT_LAND_STATIC,
  ENDPOINT_LAND_TYPES,
  ENDPOINT_MASSIVE,
  ENDPOINT_ORGANIZATIONS,
  ENDPOINT_PLANTS,
  ENDPOINT_PLANTS_TYPES,
  ENDPOINT_REGIONS,
} from '@/common/constants';
import { HttpApi } from '@/common/http';
import { IUser } from '@/common/models';
import {
  IFondsTypes,
  ILandStatic,
  ILandTypes,
  IMassive,
  IPlants,
  IPlantsTypes,
  IRegion,
  IStoreAction,
  IStoreState,
} from '@/common/models/IStore';
import { create } from 'zustand';

const httpApi = new HttpApi();

const useStore = create<IStoreState & IStoreAction>((set) => ({
  user: null,
  region: [],
  plants: [],
  plantsSelect: [],
  organizationsSelect: [],
  massives: [],
  organizations: [],
  district: [],
  fondTypes: [],
  landTypes: [],
  landStatic: [],
  plantsTypes: [],
  userLoading: false,
  plantsLoading: false,
  organizationsLoading: false,
  regionLoading: false,
  massivesLoading: false,
  districtLoading: false,
  fondTypesLoading: false,
  landTypesLoading: false,
  landStaticLoading: false,
  plantsTypesLoading: false,
  fetchUser: async () => {
    const response = await httpApi.get<IUser>(ENDPOINT_CURRENT_USER, {});
    set({ user: response });
  },
  fetchRegion: async () => {
    const response = await httpApi.get<IRegion[]>(ENDPOINT_REGIONS, {});
    set({ region: response });
  },
  fetchDistrict: async (params: { region_id: string }) => {
    set({ districtLoading: true });
    const response = await httpApi.get<IRegion[]>(
      ENDPOINT_DISTRICTS + `/${params.region_id}`,
      {},
    );
    set({ district: response });
    setTimeout(() => {
      set({ districtLoading: false });
    }, 300);
  },
  fetchMassive: async () => {
    set({ massivesLoading: true });
    const response = await httpApi.get<IMassive[]>(ENDPOINT_MASSIVE, {});
    set({ massives: response });
    setTimeout(() => {
      set({ massivesLoading: false });
    }, 300);
  },
  fetchPlants: async () => {
    set({ plantsLoading: true });
    const response = await httpApi.get<IPlants[]>(ENDPOINT_PLANTS, {});
    set({
      plants: response,
      plantsSelect: response?.map((item) => ({
        value: item?.id,
        label: item?.name,
      })),
    });
    setTimeout(() => {
      set({ plantsLoading: false });
    }, 300);
  },

   fetchOrganizations: async () => {
    set({ organizationsLoading: true });
    const response = await httpApi.get<any[]>(ENDPOINT_ORGANIZATIONS, {});
    set({
      organizations: response,
      organizationsSelect: response?.map((item) => ({
        value: item?.id,
        label: item?.name,
      })),
    });
    setTimeout(() => {
      set({ organizationsLoading: false });
    }, 300);
  },
  fetchLandStatic: async () => {
    set({ landStaticLoading: true });
    const response = await httpApi.get<ILandStatic[]>(ENDPOINT_LAND_STATIC, {});
    set({ landStatic: response });
    setTimeout(() => {
      set({ landStaticLoading: false });
    }, 300);
  },
  fetchLandTypes: async () => {
    set({ landTypesLoading: true });
    const response = await httpApi.get<ILandTypes[]>(ENDPOINT_LAND_TYPES, {});
    set({ landTypes: response });
    setTimeout(() => {
      set({ landTypesLoading: false });
    }, 300);
  },
  fetchFondTypes: async () => {
    set({ fondTypesLoading: true });
    const response = await httpApi.get<IFondsTypes[]>(ENDPOINT_FOND_TYPES, {});
    set({ fondTypes: response });
    setTimeout(() => {
      set({ fondTypesLoading: false });
    }, 300);
  },
  fetchPlantsTypes: async () => {
    set({ plantsTypesLoading: true });
    const response = await httpApi.get<IPlantsTypes[]>(
      ENDPOINT_PLANTS_TYPES,
      {},
    );
    set({ plantsTypes: response });
    setTimeout(() => {
      set({ plantsTypesLoading: false });
    }, 300);
  },
}));

export default useStore;
